/**
 * LA PILA DEI LIVELLI SOPRA LE ROTTE — chi chiude il tasto indietro di Telegram.
 *
 * Prima il BackButton nativo faceva SEMPRE `navigate(-1)` (`useBackButton`): con un foglio o una modale
 * aperti chiudeva il livello (lo smontaggio della schermata) E tornava indietro di una schermata.
 * Ora un livello aperto (un `Sheet`, la modale del check-in) si REGISTRA qui, e il tasto indietro chiude
 * SOLO quello in cima; a pila vuota torna a essere la cronologia (seguito di #434, disegno approvato da
 * tma-orcb 12:27:39Z).
 *  · UNA pila per l'app, in modulo: come il BackButton nativo, che e' uno solo;
 *  · in cima c'e' l'ultimo ATTIVATO (non l'ultimo disegnato): chi registra tiene `chiudi` in un ref;
 *  · si toglie per id, mai con `pop`: StrictMode (monta, smonta, rimonta) lascia una voce sola, nello
 *    stesso ordine, e un livello che si chiude sotto un altro non porta via quello di sopra;
 *  · un `chiudi` che non chiude (un foglio occupato che rifiuta) lascia la pila com'e': e' una sua scelta.
 * ⚠️ Pura: niente React, niente SDK. La montano `useLivelloIndietro` (chi registra) e `useBackButton`
 * (chi chiude).
 */
interface Livello {
  id: number;
  chiudi: () => void;
}

let livelli: Livello[] = [];
let prossimoId = 1;
const ascoltatori = new Set<() => void>();
const avvisa = () => {
  for (const cb of ascoltatori) cb();
};

/** Mette un livello in cima. Rende la funzione che lo toglie (per id: vale una volta sola). */
export function apriLivello(chiudi: () => void): () => void {
  const id = prossimoId++;
  livelli = [...livelli, { id, chiudi }];
  avvisa();
  return () => {
    const prima = livelli.length;
    livelli = livelli.filter((l) => l.id !== id);
    if (livelli.length !== prima) avvisa();
  };
}

/**
 * IL FRENO DELL'INDIETRO — uno slot per l'app, DOPO la pila (I-402, Luca: la conferma «Lasciare il tavolo?» vale anche per
 * il tasto indietro di Telegram, con lo stesso predicato della barra).
 *
 * Non e' un livello: un livello CHIUDE se stesso. Il freno decide se il passo indietro che sta per partire va chiesto: riceve
 * quel `passo` e rende `true` se l'ha preso in carico (ha aperto una conferma, e «Esci» lo eseguira'), `false` se si va subito.
 * Lo legge `useBackButton` SOLO a pila vuota: con un foglio aperto — compreso quello della conferma — l'indietro lo chiude
 * (e' il «Resta»), senza una seconda domanda. Uno slot solo, come il BackButton nativo; chi lo imposta lo toglie.
 * ⚠️ Pura, come la pila: niente React, niente SDK.
 */
export type FrenoIndietro = (passo: () => void) => boolean;

let freno: FrenoIndietro | null = null;

export function impostaFrenoIndietro(f: FrenoIndietro): () => void {
  freno = f;
  return () => {
    if (freno === f) freno = null;
  };
}

/** Il freno impostato, o `null`. Si legge al TOCCO, come la cima della pila. */
export function frenoIndietro(): FrenoIndietro | null {
  return freno;
}

/** Il `chiudi` del livello in cima, o `null` a pila vuota. */
export function livelloInCima(): (() => void) | null {
  return livelli.at(-1)?.chiudi ?? null;
}

/** Quanti livelli sono aperti (per `useSyncExternalStore`: un numero, stabile fra due letture). */
export function quantiLivelli(): number {
  return livelli.length;
}

export function ascoltaLivelli(cb: () => void): () => void {
  ascoltatori.add(cb);
  return () => {
    ascoltatori.delete(cb);
  };
}
